module.exports = __webpack_public_path__ + "static/media/country_za.346a62a4.webp";